module.exports = __webpack_public_path__ + "img/Git・Github.a18d155b.png";